const LEGACY_PHASE_ROWS = Object.freeze([
  { planetIndex: 0, label: '日', aliases: ['日', '太阳', 'Sun'] },
  { planetIndex: 1, label: '月', aliases: ['月', '月亮', 'Moon'] },
  { planetIndex: 2, label: '水', aliases: ['水', '水星', 'Mercury'] },
  { planetIndex: 3, label: '金', aliases: ['金', '金星', 'Venus'] },
  { planetIndex: 4, label: '火', aliases: ['火', '火星', 'Mars'] },
  { planetIndex: 5, label: '木', aliases: ['木', '木星', 'Jupiter'] },
  { planetIndex: 6, label: '土', aliases: ['土', '土星', 'Saturn'] },
  { planetIndex: 7, label: '天', aliases: ['天', '天王星', 'Uranus'] },
  { planetIndex: 8, label: '海', aliases: ['海', '海王星', 'Neptune'] },
  { planetIndex: 9, label: '冥', aliases: ['冥', '冥王星', 'Pluto'] },
  { planetIndex: 11, label: '计都', aliases: ['计都', 'Ketu'] },
  { planetIndex: 13, label: '月孛', aliases: ['月孛', 'Lilith'] },
  { planetIndex: 15, label: '凯龙', aliases: ['凯龙', '凯龙星', 'Chiron'] },
  { planetIndex: 1000014, label: 'MC', aliases: ['MC', '中天', 'Midheaven', '顶'] },
  { planetIndex: 1000015, label: 'ASC', aliases: ['ASC', '上升', '上升点', 'Ascendant', '命'] },
  { planetIndex: 1000016, label: '福点', aliases: ['福点', '幸运点', 'Fortune'] },
  { planetIndex: 1000012, label: '紫气', aliases: ['紫气', '紫炁', 'Ziqi'] },
  { planetIndex: 1000013, label: '罗睺', aliases: ['罗睺', 'Rahu'] }
])

const DEFAULT_LEGACY_TOLERANCE_MATRIX = Object.freeze([
  Object.freeze([9.0, 9.0, 9.0, 9.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([9.0, 9.0, 9.0, 9.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([7.0, 7.0, 7.0, 7.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([7.0, 7.0, 7.0, 7.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([7.0, 7.0, 7.0, 7.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([9.0, 9.0, 9.0, 9.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([9.0, 9.0, 9.0, 9.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([5.0, 5.0, 5.0, 5.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([5.0, 5.0, 5.0, 5.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([5.0, 5.0, 5.0, 5.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([5.0, 5.0, 5.0, 5.0, 5.0, 1.5, 3.0, 3.0, 3.0, 1.0, 1.0]),
  Object.freeze([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]),
  Object.freeze([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]),
  Object.freeze([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]),
  Object.freeze([2.5, 4.5, 4.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5, 2.5]),
  Object.freeze([1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.0, 1.0, 1.0, 1.0]),
  Object.freeze([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]),
  Object.freeze([2.0, 3.5, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0])
])

function cloneMatrix (matrix) {
  return matrix.map(row => row.map(cell => cell))
}

function cloneRows (rows) {
  return rows.map(row => ({
    ...row,
    aliases: [...row.aliases]
  }))
}

function isFiniteNumber (value) {
  return typeof value === 'number' && Number.isFinite(value)
}

function normalizeToleranceRow (row, fallbackRow) {
  const normalized = [...fallbackRow]
  if (!Array.isArray(row)) {
    return normalized
  }

  for (let index = 0; index < normalized.length && index < row.length; index++) {
    if (isFiniteNumber(row[index])) {
      normalized[index] = row[index]
    }
  }

  return normalized
}

function findLegacyRowIndexByPlanetIndex (planetIndex) {
  return LEGACY_PHASE_ROWS.findIndex(row => row.planetIndex === planetIndex)
}

function getDefaultLegacyToleranceMatrix () {
  return cloneMatrix(DEFAULT_LEGACY_TOLERANCE_MATRIX)
}

function getLegacyPhaseRows () {
  return cloneRows(LEGACY_PHASE_ROWS)
}

function normalizeLegacyToleranceMatrix (toleranceMatrix) {
  const normalized = getDefaultLegacyToleranceMatrix()
  if (!Array.isArray(toleranceMatrix)) {
    return normalized
  }

  for (let rowIndex = 0; rowIndex < normalized.length && rowIndex < toleranceMatrix.length; rowIndex++) {
    normalized[rowIndex] = normalizeToleranceRow(toleranceMatrix[rowIndex], normalized[rowIndex])
  }

  return normalized
}

function convertLegacyMatrixToPhaseToleranceRows (toleranceMatrix) {
  const normalizedMatrix = normalizeLegacyToleranceMatrix(toleranceMatrix)
  return LEGACY_PHASE_ROWS.map((row, rowIndex) => ({
    planetIndex: row.planetIndex,
    label: row.label,
    aliases: [...row.aliases],
    tolerances: [...normalizedMatrix[rowIndex]]
  }))
}

function convertPhaseToleranceRowsToLegacyMatrix (phaseToleranceRows, fallbackMatrix) {
  const normalizedMatrix = normalizeLegacyToleranceMatrix(fallbackMatrix)
  if (!Array.isArray(phaseToleranceRows)) {
    return normalizedMatrix
  }

  for (const row of phaseToleranceRows) {
    if (!row || row.planetIndex === undefined || row.planetIndex === null) {
      continue
    }

    const targetIndex = findLegacyRowIndexByPlanetIndex(row.planetIndex)
    if (targetIndex < 0) {
      continue
    }

    normalizedMatrix[targetIndex] = normalizeToleranceRow(row.tolerances, normalizedMatrix[targetIndex])
  }

  return normalizedMatrix
}

function resolvePhaseToleranceState ({ toleranceMatrix, phaseToleranceRows } = {}) {
  const normalizedMatrix = Array.isArray(phaseToleranceRows) && phaseToleranceRows.length > 0
    ? convertPhaseToleranceRowsToLegacyMatrix(phaseToleranceRows, toleranceMatrix)
    : normalizeLegacyToleranceMatrix(toleranceMatrix)

  return {
    toleranceMatrix: normalizedMatrix,
    phaseToleranceRows: convertLegacyMatrixToPhaseToleranceRows(normalizedMatrix)
  }
}

module.exports = {
  LEGACY_PHASE_ROWS,
  DEFAULT_LEGACY_TOLERANCE_MATRIX,
  findLegacyRowIndexByPlanetIndex,
  getDefaultLegacyToleranceMatrix,
  getLegacyPhaseRows,
  normalizeLegacyToleranceMatrix,
  convertLegacyMatrixToPhaseToleranceRows,
  convertPhaseToleranceRowsToLegacyMatrix,
  resolvePhaseToleranceState
}
